/**
 * @generated SignedSource<<186740351e4dfe7f31f7e91d3cc07db2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalSideNavigation$data = {
  readonly navPlatL1MenuData?: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null;
  readonly navPlatSidebarData?: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useGlobalShortcutsDataRelay" | "useNetworkSideNavUserData">;
  readonly " $fragmentType": "GlobalSideNavigation";
};
export type GlobalSideNavigation$key = {
  readonly " $data"?: GlobalSideNavigation$data;
  readonly " $fragmentSpreads": FragmentRefs<"GlobalSideNavigation">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v1 = [
  {
    "kind": "FragmentSpread",
    "name": "useNavSettingsService"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchGlobalShortcutsAvailableProducts"
    },
    {
      "kind": "RootArgument",
      "name": "fetchOldEntityRecord"
    },
    {
      "kind": "RootArgument",
      "name": "navPlatMenuDataEntityAri"
    },
    {
      "kind": "RootArgument",
      "name": "navPlatSidebarDataEntityAri"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    },
    {
      "kind": "RootArgument",
      "name": "skipNavPlatSidebarData"
    }
  ],
  "kind": "Fragment",
  "name": "GlobalSideNavigation",
  "selections": [
    {
      "condition": "fetchOldEntityRecord",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useNetworkSideNavUserData"
        }
      ]
    },
    {
      "condition": "fetchGlobalShortcutsAvailableProducts",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useGlobalShortcutsDataRelay"
        }
      ]
    },
    {
      "condition": "skipNavPlatSidebarData",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "navPlatL1MenuData",
          "args": [
            {
              "kind": "Variable",
              "name": "entityAri",
              "variableName": "navPlatMenuDataEntityAri"
            },
            (v0/*: any*/)
          ],
          "concreteType": "SettingsNavigationCustomisation",
          "kind": "LinkedField",
          "name": "settings_navigationCustomisation",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "alias": "navPlatSidebarData",
          "args": [
            {
              "kind": "Variable",
              "name": "entityAri",
              "variableName": "navPlatSidebarDataEntityAri"
            },
            (v0/*: any*/)
          ],
          "concreteType": "SettingsNavigationCustomisation",
          "kind": "LinkedField",
          "name": "settings_navigationCustomisation",
          "plural": false,
          "selections": (v1/*: any*/)
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "cf55f7cf94bfdcc4b1b2ad3da5239bc5";

export default node;
